import React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import RefreshIcon from "@material-ui/icons/Refresh";
import {
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
  INSIDE_THE_HEADER
} from "constants/ActionTypes";
import { toggleCollapsedNav } from "actions/Setting";
import Menu from "components/TopNav/Menu";
import SystemStatusChip from "components/SystemStatusChip";
import { refreshApp } from "util/appRefresh";
import dashboardLogo from "../../assets/images/logos/flip-hztl-pmry-lg.png";

class Header extends React.Component {
  state = {
    isRefreshing: false
  };

  onToggleCollapsedNav = () => {
    const val = !this.props.navCollapsed;
    this.props.toggleCollapsedNav(val);
  };

  handleRefreshApp = async () => {
    if (this.state.isRefreshing) {
      return;
    }

    this.setState({ isRefreshing: true });
    await refreshApp();
  };

  render() {
    const { isRefreshing } = this.state;
    const { drawerType, navigationStyle, horizontalNavPosition } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER)
      ? "d-block d-xl-none"
      : drawerType.includes(COLLAPSED_DRAWER)
      ? "d-block"
      : "d-none";

    return (
      <AppBar
        className={`app-main-header ${
          navigationStyle === HORIZONTAL_NAVIGATION &&
          horizontalNavPosition === BELOW_THE_HEADER
            ? "app-main-header-top"
            : ""
        }`}
        color="default"
        elevation={0}
      >
        <Toolbar className="app-toolbar" disableGutters={false}>
          {navigationStyle === HORIZONTAL_NAVIGATION ? (
            <div
              className="d-block d-md-none pointer mr-3"
              onClick={this.onToggleCollapsedNav}
            >
              <span className="jr-menu-icon">
                <span className="menu-icon" />
              </span>
            </div>
          ) : (
            <IconButton
              className={`jr-menu-icon mr-3 ${drawerStyle}`}
              aria-label="Menu"
              onClick={this.onToggleCollapsedNav}
            >
              <span className="menu-icon" />
            </IconButton>
          )}

          <Link className="app-logo mr-2 d-none d-sm-block" to="/">
            <img
              src={dashboardLogo}
              alt="iflip admin"
              title="iFlip Admin Home"
              loading="eager"
              fetchpriority="high"
              decoding="async"
            />
          </Link>

          {navigationStyle === HORIZONTAL_NAVIGATION &&
            horizontalNavPosition === INSIDE_THE_HEADER && <Menu />}

          <div className="app-toolbar-actions ml-auto">
            <SystemStatusChip />
            <Tooltip title="Reload the app and pull in the latest deployed version">
              <span>
                <Button
                  className="app-refresh-button"
                  color="primary"
                  variant="outlined"
                  size="small"
                  onClick={this.handleRefreshApp}
                  disabled={isRefreshing}
                  startIcon={
                    <RefreshIcon
                      className={
                        isRefreshing ? "app-refresh-button-icon-spinning" : ""
                      }
                    />
                  }
                >
                  <span className="app-refresh-button-label">
                    {isRefreshing ? "Refreshing..." : "Refresh app"}
                  </span>
                </Button>
              </span>
            </Tooltip>
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

const mapStateToProps = state => {
  const { drawerType, navigationStyle, horizontalNavPosition } = state.settings;
  return {
    drawerType,
    navigationStyle,
    horizontalNavPosition
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { toggleCollapsedNav }
  )(Header)
);
